<h1 mat-dialog-title>
  <ng-container i18n="Contest Preview Modal|Contest Preview modal title@@contest-preview-modal-title">
    Contest Preview
  </ng-container>
</h1>
<div mat-dialog-content #dialogContent class="full-width details-content">
  <p i18n="Contest Preview|Contest Preview details@@contest-preview-details">
    You will be able to preview the contest as students will see it. Please note that you can answer questions, but
    responses are not recorded and scored.
  </p>
  <p>
    <a [routerLink]="getPreviewUrl" target="_blank" class="word-wrap">
      <ng-container *ngIf="contest && contest.name">{{contest.name}}</ng-container>
      <ng-container *ngIf="!contest?.name"
                    i18n="Contest Preview Modal|Contest Preview modal title@@contest-preview-modal-title">
        Contest Preview
      </ng-container>
    </a>
  </p>
</div>
<div mat-dialog-actions>
  <app-button [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"
              label="Close"
              i18n-label="General|Close action label@@general-close-action-label"></app-button>
</div>
